import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import ChargeItem from "./ChargeItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import {GET_CHARGES} from "../../queries/customers";
import {requestViewChargePayments} from "../../actions/AccountApiActions";

class ChargesList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedId: ""
    }
  }

  render() {
    let params = {accountId: this.props.accountId}
    let tableHeader = List([
      "Order Id",
      "Amount",
      "Status",
      "Kind",
      "Due Date",
      "Last Updated",
      ""
    ])              
    return (
      <Query query={GET_CHARGES} variables={params} fetchPolicy="network-only">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let charges = fromJS(data.billingCharges);
          if (charges.size === 0) {
            return <EmptyStatus status="No charges found" />
          }
          return (
            <div>
              <Table 
                data={charges} 
                mode="table"
                renderer={ChargeItem} 
                tableHeader={tableHeader}
                itemKey="salesOrderId"
                onContextMenuClick={this.handleContextMenuClick.bind(this)}
                />
            </div>
          )
        }}
      </Query>
    )
  }

  handleContextMenuClick(id) {
    this.props.requestViewChargePayments(this.props.accountId, id);
  }
}

ChargesList.defaultProps = {
  accountId: ""
}

export default connect(null, {requestViewChargePayments})(ChargesList);